import type { WikiBlock } from "./types";

/**
 * Escape plain text for wiki HTML attributes / text nodes.
 */
export function escapeWikiHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** Structured wiki blocks → HTML (no raw author HTML). */
export function renderWikiBlocks(blocks: readonly WikiBlock[]): string {
  const parts: string[] = [];
  for (const b of blocks) {
    switch (b.type) {
      case "h2":
        parts.push(`<h2 class="raid-wiki-h2">${escapeWikiHtml(b.text)}</h2>`);
        break;
      case "h3":
        parts.push(`<h3 class="raid-wiki-h3">${escapeWikiHtml(b.text)}</h3>`);
        break;
      case "p":
        parts.push(`<p class="raid-wiki-p">${escapeWikiHtml(b.text)}</p>`);
        break;
      case "ul":
        parts.push(
          `<ul class="raid-wiki-ul">${b.items
            .map((it) => `<li>${escapeWikiHtml(it)}</li>`)
            .join("")}</ul>`,
        );
        break;
      case "table": {
        const head = b.headers
          .map((h) => `<th>${escapeWikiHtml(h)}</th>`)
          .join("");
        const body = b.rows
          .map(
            (row) =>
              `<tr>${row.map((c) => `<td>${escapeWikiHtml(c)}</td>`).join("")}</tr>`,
          )
          .join("");
        parts.push(
          `<table class="raid-wiki-table"><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>`,
        );
        break;
      }
      case "callout":
        parts.push(
          `<div class="raid-wiki-callout tone-${b.tone}">${escapeWikiHtml(b.text)}</div>`,
        );
        break;
      default: {
        const _x: never = b;
        return _x;
      }
    }
  }
  return parts.join("\n");
}
